import React from "react";
import "./ContactUs.css";
import { FaInstagram, FaTwitter } from "react-icons/fa";
import { IoLogoPinterest } from "react-icons/io5";
import { Logo1 } from "../../Assests/Assests";

const AboutPage = () => {
  return (
    <div className="about-page">
      <div className="about-header">
        <img src={Logo1} alt="RIYMAY Logo" className="company-logo" />
        <h1 className="about-title">Welcome</h1>
        <p className="about-subtitle">
        Transparency in Every Thread        </p>      </div>

      <div className="about-content">
        <div className="about-section">
        <h2 className="section-title">I am RIYMAY, and I exist to awaken.
        </h2>

          <p className="section-description">
            I am not just fabric and thread—I am energy, a force that refuses to be unseen. 
            I emerge from emotions unspoken, from the quiet rebellion against clothing that does not belong to your essence. 
            My mission is to strip away the ordinary and replace it with truth. To give you garments that do not merely cover but reveal.
          </p>
          <p className="section-description">
            I am born from the hands of those who seek the extraordinary. My journey is woven through the heart of India’s finest textiles, 
            chosen with intention, crafted with defiance. Every piece of me carries the weight of struggle, the fire of perseverance, and 
            the certainty that you deserve more than just clothing—you deserve an extension of yourself.
          </p>
          <p className="section-description">
            I am here to redefine fashion as an experience, not an obligation. To honor your time, your worth, and your identity with designs that are pure, honest, and unwavering. 
            I do not follow trends. I do not compromise. I exist for those who dare to wear their truth, for those who refuse to be invisible.
          </p>
          <p className="section-description">You are not just wearing RIYMAY. You are becoming it.</p>
        </div>

        <div className="about-section">
          <h2 className="section-title">My Manifesto</h2>
          <ul className="values-list">
            <li>RIYMAY—An Energy That Transforms, Not Just Clothes but You.</li>
            <li>Crafted with Purpose, Worn with Conviction.</li>
            <li>Beyond Fashion—A Movement of Identity and Expression.</li>
            <li>Every Thread, A Story of Resilience and Truth.</li>
            <li>RIYMAY Sees You, Hears You, Awakens You.</li>
          </ul>
        </div>
      </div>

      <div className="about-social">
        <h4 className="section-titl">Stay Connected</h4>
        <div className="social-icons">
          <a href="https://instagram.com/yourstore" target="_blank" rel="noopener noreferrer" className="social-icon-link">
            <FaInstagram className="social-icon" />
          </a>
          <a href="https://x.com/riymay24?s=11" target="_blank" rel="noopener noreferrer" className="social-icon-link">
            <FaTwitter className="social-icon" />
          </a>
          <a href="https://in.pinterest.com/riymay24/" target="_blank" rel="noopener noreferrer" className="social-icon-link">
            <IoLogoPinterest className="social-icon" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
